import { DELETE, GET, PATCH, POST, POST_BLOB } from "../API";

const toShortLanguageCode = (locale) => {
  if (!locale) return "en";
  return locale.split("-")[0].split("_")[0];
};

export const createVoiceClone = (audioBlob, locale, onSuccess, onError) => {
  const ext = audioBlob.type === "audio/ogg" ? "ogg" : "webm";
  const formData = new FormData();
  formData.append("audio", audioBlob, `voice_sample.${ext}`);
  formData.append("language", toShortLanguageCode(locale));
  POST("/api/v1/voice_clones", formData, onSuccess, onError);
};

export const getVoiceClone = (voiceId, onSuccess, onError) => {
  GET(`/api/v1/voice_clones/${voiceId}`, onSuccess, onError);
};

export const activateVoiceClone = (voiceId, onSuccess, onError) => {
  PATCH(`/api/v1/voice_clones/${voiceId}/activate`, {}, onSuccess, onError);
};

export const deleteVoiceClone = (voiceId, onSuccess, onError) => {
  DELETE(`/api/v1/voice_clones/${voiceId}`, onSuccess, onError);
};

export const speakWithClonedVoice = (text, voiceId, onSuccess, onError) => {
  POST_BLOB(
    "/api/v1/voice_clones/speak",
    { text, voice_id: voiceId },
    onSuccess,
    onError,
    true,
    null,
    true
  );
};

export const previewDefaultVoice = (text, locale, onSuccess, onError) => {
  POST_BLOB(
    "/api/v1/chat/audio/speak",
    { text, to: toShortLanguageCode(locale) },
    onSuccess,
    onError,
    true,
    null,
    true
  );
};
